<template>
	<div class="form__checkbox-item" v-if="getStage && (getStage.toUpperCase() == item.stage.toUpperCase() || item.stage.toUpperCase() == 'ALL')">
		<input :id="item.id" :name="item.id" type="checkbox" :value="item.value" :checked="item.checked" data-js-item="js-filter-newsroom-event-checkbox" class="form__checkbox-input" />
		<label :for="item.id" class="form__checkbox-label">
			{{item.title}}
		</label>
	</div>
	<div class="form__checkbox-item" v-else-if="!getStage">
		<input :id="item.id" :name="item.id" type="checkbox" :value="item.value" :checked="item.checked" data-js-item="js-filter-newsroom-event-checkbox" class="form__checkbox-input" />
		<label :for="item.id" class="form__checkbox-label">
			{{item.title}}
		</label>
	</div>
</template>
<script>
export default {
  	name: "FilterNewsroomEventCheckboxItem",
	props: ["item"],
  	components: {
  	},
  	computed: {
		getStage() {
      		return this.$store.getters.stage;
		}
  	}
};
</script>
